import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DynamicDialogService } from 'src/app/shared/components/dynamic-dialog/services/dynamic-dialog.service';
import { LoginFormComponent } from 'src/app/shared/components/login-form/login-form.component';

@Component({
    selector: 'app-auto-pay-login',
    standalone: true,
    imports: [LoginFormComponent, MatIconModule, MatButtonModule],
    templateUrl: './auto-pay-login.component.html',
    styleUrl: './auto-pay-login.component.scss',
})
export class AutoPayLoginComponent {
    constructor(private dynamicDialogService: DynamicDialogService) {}

    forgotPW(): void {
        this.dynamicDialogService.closeDialog();
    }
}
